import config from "@/lib/config";

export default function absoluteURL({ url }) {
  //もし相対アドレスなら絶対アドレスに変える
  if (/^https?:\/\//.test(url)) {
    return url;
  } else {
    const host = config.host.vod;
    return [host, ...url.split("/")].join("/");
  }
}
